import styled from '@emotion/styled';
import Image from '../Image';
import { IconButton } from '@mui/material';

export const Root = styled.div`
  display: flex;
  min-height: ${({ theme }) => theme.spacing(8)};
  align-items: center;

  .MuiInputBase-root,
  input {
    display: none;
  }
`;

export const Label = styled.label`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: 1px dashed ${({ theme }) => theme.palette.divider};
  border-radius: ${({ theme }) => theme.spacing(1)};
  padding: ${({ theme }) => theme.spacing(2)};
  min-height: 96px;
`;

export const Description = styled.div`
  margin-top: ${({ theme }) => theme.spacing(1)};
  text-align: center;
`;

export const Container = styled.div`
  position: relative;
  max-width: 100%;
  overflow: hidden;
  min-width: 150px;
  min-height: 128px;
  display: flex;
`;

export const StyledImage = styled(Image)`
  box-sizing: border-box;
  border-radius: ${({ theme }) => theme.spacing(1)};
  flex: 1;
  width: 100%;
  border: 1px solid ${({ theme }) => theme.palette.divider};
`;

export const RemoveButton = styled(IconButton)`
  position: absolute;
  right: ${({ theme }) => theme.spacing(0.5)};
  top: ${({ theme }) => theme.spacing(0.5)};
  color: ${({ theme }) => theme.palette.common.black};
  background-color: ${({ theme }) => theme.palette.action.selected};
`;
